// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2PXkh","fileBtn":"File_fileBtn__P0Qtj","closeBtn":"File_closeBtn__RiJCR","fileSelected":"File_fileSelected__YD9WL","disabled":"File_disabled__tIG2w"};